import { IconProps } from '../../icons/types';

const AgentLatestLocationIcon = (props: IconProps) => {
  const { fillColor, fillColor1, fillColor2, width = '20', height = '30' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <path
        d="M19.9362 9.96831C19.9362 15.4736 9.96808 30 9.96808 30C9.96808 30 0 15.4736 0 9.96831C0 4.46294 4.46288 0 9.96808 0C15.4733 0 19.9362 4.46294 19.9362 9.96831Z"
        fill={fillColor}
      />
      <path
        d="M1.70898 10.8462C1.70898 6.06371 5.58586 2.18674 10.3682 2.18674C13.1636 2.18674 15.6491 3.51168 17.2324 5.56746C15.7371 2.97159 12.9345 1.22397 9.72369 1.22397C4.94134 1.22397 1.06445 5.10094 1.06445 9.88345C1.06445 11.8705 1.73418 13.7008 2.85961 15.1621C2.12772 13.8915 1.70898 12.4178 1.70898 10.8462Z"
        fill={fillColor1}
      />
      <path
        d="M7.61719 26.1874C8.97542 28.4632 9.96793 30 9.96793 30C9.96793 30 19.936 15.4736 19.936 9.96831C19.936 9.67924 19.921 9.39383 19.8969 9.111C19.5034 10.6404 18.9473 12.1296 18.2646 13.5508C16.3779 17.4784 13.5876 19.995 10.6157 23.1814C9.65765 24.2085 8.66043 25.2243 7.61719 26.1874Z"
        fill={fillColor2}
      />
    </svg>
  );
};

export default AgentLatestLocationIcon;
